import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

/* 
    COMPONENT TO SHOW A LARGE TEXT UPTO A PARTICULAR LENGTH
    REST OF THE TEXT IS SHOWN USING BOOTSTRAP 4 OR REACTSTRAP TOOLTIP ON HOVER
*/

interface TypeLargeText {
    data: string;
    lengthToBeShown?: number;
};

export default function LargeText({ data, lengthToBeShown }: TypeLargeText) {

    // const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
    // const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <React.Fragment>
            {/* FOR BOOTSTRAP */}
            <span data-toggle="tooltip" data-placement="top" title={data || ''} style={{ cursor: 'pointer' }}>
                {data?.length > 20 ? (data.slice(0, lengthToBeShown || 20) + '...') : data}
            </span>

            {/* The below code is for reactstrap tooltip which is causing unnecessary re-rendering issue */}
            {/* <span id="tooltip" className="pointer">{data.length > 20 ? (data.slice(0, lengthToBeShown || 20) + '...') : data || ''}</span>
            <Tooltip placement="right" isOpen={tooltipOpen} target="tooltip" toggle={toggle}>
                {data}
            </Tooltip> */}
        </React.Fragment>
    )
}
